import {Component, Input, OnInit} from '@angular/core';
import {InputMask} from '../../../models/form-elements.model';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';

@Component({
  selector: 'app-input-text-disabled',
  templateUrl: './input-text-disabled.component.html',
  styleUrls: ['./input-text-disabled.component.scss']
})
export class InputTextDisabledComponent implements OnInit {

  @Input() label: string;
  @Input() value: string;
  @Input() style: 'bordered' | 'default' = 'default';
  @Input() theme: 'light' | 'dark' = 'light';
  @Input() isGrey = true;
  @Input() hasBorder = true;
  @Input() numberMask: InputMask;
  @Input() usePipe?: boolean;

  mask: InputMask;

  constructor() {
  }

  ngOnInit() {
    this.mask = this.createStandardNumberMask(this.numberMask);
  }

  createStandardNumberMask(options?: InputMask) {
    if (this.numberMask) {
      const config = {
        prefix: '',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: false,
        decimalSymbol: '.',
        decimalLimit: 2,
        integerLimit: undefined,
        requireDecimal: false,
        allowNegative: false,
        allowLeadingZeroes: false,
        ...options
      };
      return createNumberMask(config);
    }

    return {};
  }
}
